import React from 'react';

const AddressIcon = ({ fill }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <mask
        id='mask0_2276_8992'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='25'
        height='24'
      >
        <path d='M24.5 0H0.5V24H24.5V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_2276_8992)'>
        <path
          d='M13.0958 20.0792C13.1666 20.035 14.8475 18.975 16.5325 17.12C18.8175 14.605 20.025 11.8083 20.025 9.03333C20.025 6.88167 19.2366 4.93833 17.805 3.55917C16.4258 2.23083 14.5416 1.5 12.4991 1.5C10.4566 1.5 8.57245 2.23167 7.19329 3.55917C5.76162 4.9375 4.97412 6.88167 4.97412 9.03333C4.97412 11.8083 6.18162 14.605 8.46662 17.12C10.1516 18.975 11.8325 20.035 11.9033 20.0792L12.1766 20.25H5.74995L4.99995 22.5H19.25L20 20.25H12.8225L13.0958 20.0792ZM7.22495 9.03333C7.22495 7.47667 7.75412 6.14417 8.75495 5.18C9.71245 4.2575 11.0425 3.75 12.5 3.75C13.9575 3.75 15.2866 4.2575 16.245 5.18C17.2458 6.14417 17.7758 7.47667 17.7758 9.03333C17.7758 13.3733 13.9941 16.6325 12.5008 17.7508C11.0058 16.6317 7.22579 13.3725 7.22579 9.03333H7.22495Z'
          fill={fill}
        />
        <path
          d='M16.2416 8.99997C16.2416 6.93663 14.5633 5.2583 12.5 5.2583C10.4366 5.2583 8.7583 6.93663 8.7583 8.99997C8.7583 11.0633 10.4366 12.7416 12.5 12.7416C14.5633 12.7416 16.2416 11.0633 16.2416 8.99997ZM12.5 10.4916C11.6775 10.4916 11.0083 9.82247 11.0083 8.99997C11.0083 8.17747 11.6775 7.5083 12.5 7.5083C13.3225 7.5083 13.9916 8.17747 13.9916 8.99997C13.9916 9.82247 13.3225 10.4916 12.5 10.4916Z'
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default AddressIcon;
